import React from "react";
import { PeekStack } from "@piiqtechnologies/ui-components";
import ErrorComponent from "@components/common/error";
export const Error = ({ errorCode }) => {
    return (React.createElement(PeekStack, { flexDirection: "column", justifyContent: "space-between" },
        React.createElement(ErrorComponent, { errorCode: errorCode })));
};
export default Error;
